import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import AddPendingIssueModalV3 from "./AddPendingIssueModalV3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";

class AddWorkPerformedModalV3 extends Component {
  state = {
    selectedWpType: "item", // Set to item by default
    selectedItem: null,
    itemId: null,
    selectedCco: null,
    ccoId: null,
    selectedPendingIssue: null,
    pendingIssueId: null,
    isIdle: false,
    /** @type {number[]} */
    itemIdsToDisable: [],
    /** @type {number[]} */
    ccoIdsToDisable: [],
    /** @type {number[]} */
    pendingIssueIdsToDisable: [],
    nonIdleWp: {
      items: [],
      ccos: [],
      pendingIssues: [],
    },
    idleWp: {
      items: [],
      ccos: [],
      pendingIssues: [],
    },
    errors: {},
    showModal_addPi: false,
  };

  componentDidMount() {
    // Build list items to disable
    this.setOptionsToDisable();
  }

  setOptionsToDisable = () => {
    const { workPerformedClient } = this.props;

    let itemIdsToDisable = [];
    let ccoIdsToDisable = [];
    let pendingIssueIdsToDisable = [];
    let nonIdleWp = { items: [], ccos: [], pendingIssues: [] };
    let idleWp = { items: [], ccos: [], pendingIssues: [] };

    for (const wpTabId in workPerformedClient) {
      const wp = workPerformedClient[wpTabId];
      if (wp.itemId)
        !wp.isIdle ? nonIdleWp.items.push(wp.itemId) : idleWp.items.push(wp.itemId);
      if (wp.ccoId)
        !wp.isIdle ? nonIdleWp.ccos.push(wp.ccoId) : idleWp.ccos.push(wp.ccoId);
      if (wp.pendingIssueId)
        !wp.isIdle
          ? nonIdleWp.pendingIssues.push(wp.pendingIssueId)
          : idleWp.pendingIssues.push(wp.pendingIssueId);
    }

    nonIdleWp.items.forEach((i) => idleWp.items.includes(i) && itemIdsToDisable.push(i));
    nonIdleWp.ccos.forEach((c) => idleWp.ccos.includes(c) && ccoIdsToDisable.push(c));
    nonIdleWp.pendingIssues.forEach(
      (pi) => idleWp.pendingIssues.includes(pi) && pendingIssueIdsToDisable.push(pi)
    );

    this.setState({
      itemIdsToDisable,
      ccoIdsToDisable,
      pendingIssueIdsToDisable,
      nonIdleWp,
      idleWp,
    });
  };

  disableSubmit = () => {
    const { selectedWpType, itemId, ccoId, pendingIssueId } = this.state;
    if (selectedWpType === "item") return !itemId;
    if (selectedWpType === "cco") return !ccoId;
    if (selectedWpType === "pendingIssue") return !pendingIssueId;
    else return true; // Default is to disable
  };

  isItemDisabled = (itemOption) =>
    this.state.itemIdsToDisable.includes(itemOption.value) ? true : false;

  isCcoDisabled = (ccoOption) =>
    this.state.ccoIdsToDisable.includes(ccoOption.value) ? true : false;

  isPendingIssueDisabled = (piOption) =>
    this.state.pendingIssueIdsToDisable.includes(piOption.value) ? true : false;

  handleChange_item = (selectedItem) =>
    this.setState({ itemId: selectedItem.value, selectedItem }, this.validateChosenWp);

  handleChange_cco = (selectedCco) =>
    this.setState({ ccoId: selectedCco.value, selectedCco }, this.validateChosenWp);

  handleChange_pendingIssue = (selectedPendingIssue) =>
    this.setState(
      { pendingIssueId: selectedPendingIssue.value, selectedPendingIssue },
      this.validateChosenWp
    );

  handleChange_isIdle = (e) => this.setState({ isIdle: e.target.checked });

  setWorkPerformedType = (e) =>
    this.setState({ selectedWpType: e.target.name }, this.validateChosenWp);

  handleClick_addPendingIssue = (e) => {
    e.preventDefault();
    this.toggleModal_addPi();
  };

  toggleModal_addPi = () =>
    this.setState({
      showModal_addPi: !this.state.showModal_addPi,
    });

  resetErrors = () =>
    this.setState({
      errors: {
        item: null,
        cco: null,
        pendingIssue: null,
        wpMustBeIdle: false,
        wpMustBeNonIdle: false,
      },
    });

  validateChosenWp = () => {
    const { selectedWpType, itemId, ccoId, pendingIssueId, nonIdleWp, idleWp } =
      this.state;
    const errors = {
      item: null,
      cco: null,
      pendingIssue: null,
      wpMustBeIdle: false,
      wpMustBeNonIdle: false,
    };

    switch (selectedWpType) {
      case "item":
        errors.item = !itemId && "No item selected";
        errors.wpMustBeIdle = nonIdleWp.items.includes(itemId);
        errors.wpMustBeNonIdle = idleWp.items.includes(itemId);
        break;
      case "cco":
        errors.cco = !ccoId && "No CCO selected";
        errors.wpMustBeIdle = nonIdleWp.ccos.includes(ccoId);
        errors.wpMustBeNonIdle = idleWp.ccos.includes(ccoId);
        break;
      case "pendingIssue":
        errors.pendingIssue = !pendingIssueId && "No Pending Issue selected";
        errors.wpMustBeIdle = nonIdleWp.pendingIssues.includes(pendingIssueId)
          ? true
          : false;
        errors.wpMustBeNonIdle = idleWp.pendingIssues.includes(pendingIssueId)
          ? true
          : false;
        break;
      default:
        break;
    }

    this.setState({ errors, isIdle: errors.wpMustBeIdle });
  };

  getWpTypeString = () => {
    const { selectedWpType } = this.state;
    if (selectedWpType === "item") return "item";
    if (selectedWpType === "cco") return "CCO";
    if (selectedWpType === "pendingIssue") return "Pend. Issue";
    return "";
  };

  /**
   *
   * @returns {import("../../_typedefs/adrV3TypeDefs").WorkPerformedCaptions}
   */
  getWpCaptions = () => {
    const { projItemList, projCcoList, projPendingIssueList } = this.props;
    const { selectedWpType, itemId, ccoId, pendingIssueId } = this.state;

    /** @type {import("../../_typedefs/adrV3TypeDefs").WorkPerformedCaptions} */
    const defaultRetVal = {
      wpShortCaption: "(N/A)",
      wpFullCaption: "(N/A)",
      wpShortId: "(N/A)",
      unitOfMeasure: "",
    };
    if (!projItemList || !projCcoList || !projPendingIssueList) return defaultRetVal;
    if (selectedWpType === "item") {
      const item = (projItemList || []).find((i) => i.bidItemId === itemId);
      return {
        wpShortCaption: item ? item.itemShortCaption : "(N/A)",
        wpFullCaption: item ? item.itemFullCaption : "(N/A)",
        wpShortId: item ? item.itemShortId : "(N/A)",
        unitOfMeasure: item ? item.unitOfMeasure : "",
      };
    } else if (selectedWpType === "cco") {
      const cco = (projCcoList || []).find((c) => c.ccoId === ccoId);
      return {
        wpShortCaption: cco ? cco.ccoShortCaption : "(N/A)",
        wpFullCaption: cco ? cco.ccoFullCaption : "(N/A)",
        wpShortId: cco ? cco.ccoShortId : "(N/A)",
        unitOfMeasure: "",
      };
    } else if (selectedWpType === "pendingIssue") {
      const pi = (projPendingIssueList || []).find(
        (pi) => pi.pendingIssueId === pendingIssueId
      );
      return {
        wpShortCaption: pi ? pi.pendingIssueShortCaption : "(N/A)",
        wpFullCaption: pi ? pi.pendingIssueFullCaption : "(N/A)",
        wpShortId: pi ? pi.pendingIssueShortId : "(N/A)",
        unitOfMeasure: "",
      };
    }

    return defaultRetVal;
  };

  handleSubmit_addWp = (e) => {
    const { toggleModal_addWp, addWp } = this.props;
    const { selectedWpType, itemId, ccoId, pendingIssueId, isIdle } = this.state;
    e.preventDefault();
    const captions = this.getWpCaptions();
    let newWp = {
      workPerformedId: 0,
      itemId: selectedWpType === "item" ? itemId : null,
      ccoId: selectedWpType === "cco" ? ccoId : null,
      pendingIssueId: selectedWpType === "pendingIssue" ? pendingIssueId : null,
      isIdle,
      wpShortCaption: captions.wpShortCaption,
      wpFullCaption: captions.wpFullCaption,
      wpShortId: captions.wpShortId,
      unitOfMeasure: captions.unitOfMeasure,
      locationWorkPerformed: [],
    };

    toggleModal_addWp();
    addWp(newWp);
  };

  render() {
    const {
      showModal_addWp,
      toggleModal_addWp,
      projectId,
      className,
      projItemList,
      projCcoList,
      projPendingIssueList,
    } = this.props;
    const {
      selectedItem,
      selectedCco,
      selectedPendingIssue,
      selectedWpType,
      isIdle,
      errors,
      showModal_addPi,
    } = this.state;

    const closeBtn = (
      <button className="close" onClick={toggleModal_addWp}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <React.Fragment>
        <Modal
          isOpen={showModal_addWp}
          toggle={toggleModal_addWp}
          className={className}
          fade={false}
          size={"lg"}
        >
          <ModalHeader
            toggle={toggleModal_addWp}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="drafting-compass" className="fa-fw mr-2" />
            Add Work Performed
          </ModalHeader>
          <ModalBody>
            <form
              id="addWorkPerformedForm"
              onSubmit={this.handleSubmit_addWp}
              autoComplete="off"
            >
              <div className="card">
                <div className="card-body">
                  <div className="form-row">
                    <div className="col-sm-3">
                      <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                        <div className="radio">
                          <input
                            type="radio"
                            name="item"
                            id="item"
                            checked={selectedWpType === "item"}
                            onChange={this.setWorkPerformedType}
                            className="custom-control-input"
                          />
                          <label htmlFor="item" className="custom-control-label my-auto">
                            <b>Item:</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group item-cco-toggle">
                        <Select
                          name="itemId"
                          id="itemId"
                          isDisabled={selectedWpType !== "item"}
                          value={selectedItem}
                          options={_.orderBy(
                            (projItemList || []).map((i) => ({
                              value: i.bidItemId,
                              label: i.itemListCaption,
                              itemNo: i.itemNo,
                            })),
                            "itemNo",
                            "asc"
                          )}
                          isOptionDisabled={(option) => this.isItemDisabled(option)}
                          onChange={this.handleChange_item}
                          placeholder="(Select an Item)"
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                        {errors.item && (
                          <span className="error-small">
                            <small>{errors.item}</small>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-sm-3">
                      <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                        <div className="radio">
                          <input
                            type="radio"
                            name="cco"
                            id="cco"
                            checked={selectedWpType === "cco"}
                            onChange={this.setWorkPerformedType}
                            className="custom-control-input"
                          />
                          <label htmlFor="cco" className="custom-control-label my-auto">
                            <b>CCO:</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="form-group item-cco-toggle">
                        <Select
                          name="ccoId"
                          id="ccoId"
                          isDisabled={selectedWpType !== "cco"}
                          value={selectedCco}
                          options={_.orderBy(
                            (projCcoList || []).map((c) => ({
                              value: c.ccoId,
                              label: c.ccoListCaption,
                              ccoNo: c.ccoNo,
                            })),
                            "ccoNo",
                            "asc"
                          )}
                          isOptionDisabled={(option) => this.isCcoDisabled(option)}
                          onChange={this.handleChange_cco}
                          placeholder="(Select a CCO)"
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                        {errors.cco && (
                          <span className="error-small">
                            <small>{errors.cco}</small>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-sm-3">
                      <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                        <div className="radio">
                          <input
                            type="radio"
                            name="pendingIssue"
                            id="pendingIssue"
                            checked={selectedWpType === "pendingIssue"}
                            onChange={this.setWorkPerformedType}
                            className="custom-control-input"
                          />
                          <label
                            htmlFor="pendingIssue"
                            className="custom-control-label my-auto"
                          >
                            <b>Pending Issue:</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-7">
                      <div className="form-group mb-0">
                        <Select
                          name="pendingIssueId"
                          id="pendingIssueId"
                          isDisabled={selectedWpType !== "pendingIssue"}
                          value={selectedPendingIssue}
                          options={_.orderBy(
                            (projPendingIssueList || []).map((pi) => ({
                              value: pi.pendingIssueId,
                              label: pi.pendingIssueFullCaption,
                              pendingIssueNo: pi.pendingIssueNo,
                            })),
                            "pendingIssueNo",
                            "asc"
                          )}
                          isOptionDisabled={(option) =>
                            this.isPendingIssueDisabled(option)
                          }
                          onChange={this.handleChange_pendingIssue}
                          placeholder="(Select a Pending Issue)"
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                        {errors.pendingIssue && (
                          <span className="error-small">
                            <small>{errors.pendingIssue}</small>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-1 float-right">
                      <button
                        name="addPendingIssue"
                        id="addPendingIssue"
                        className="btn btn-secondary float-right"
                        onClick={this.handleClick_addPendingIssue}
                        disabled={selectedWpType !== "pendingIssue"}
                      >
                        <FontAwesomeIcon icon="plus" />
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="form-row">
                    <div className="col-sm-6 my-auto">
                      <div className="form-check-inline custom-control custom-checkbox ml-2">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="isIdle"
                          id="isIdle"
                          checked={isIdle}
                          onChange={this.handleChange_isIdle}
                          disabled={errors.wpMustBeIdle || errors.wpMustBeNonIdle}
                        />
                        <label htmlFor="isIdle" className="custom-control-label">
                          <b>Add as Idle</b>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {errors.wpMustBeIdle && (
                <div className="alert alert-danger mt-2 mb-0 p-2">
                  <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
                  {`Non-idle entry of this ${this.getWpTypeString()} already exists. You can now only add this ${this.getWpTypeString()} as idle.`}
                </div>
              )}
              {errors.wpMustBeNonIdle && (
                <div className="alert alert-danger mt-2 mb-0 p-2">
                  <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
                  {`An idle entry of this ${this.getWpTypeString()} already exists. You can now only add this ${this.getWpTypeString()} as a non-idle item.`}
                </div>
              )}
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group">
              <input
                className="btn btn-primary"
                name="addWorkPerformed"
                type="submit"
                form="addWorkPerformedForm"
                onClick={this.handleSubmit_addWp}
                value="Add"
                disabled={this.disableSubmit()}
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleModal_addWp}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showModal_addPi && (
          <AddPendingIssueModalV3
            showModal_addPi={showModal_addPi}
            toggleModal_addPi={this.toggleModal_addPi}
            projectId={projectId}
            callback={() => {}}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  workPerformedClient: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].workPerformedClient || null
    : null,
  projItemList: state.bidItems.projItemLists[ownProps.projectId] || null,
  projCcoList: state.ccos.projCcoLists[ownProps.projectId] || null,
  projPendingIssueList:
    state.pendingIssues.projPendingIssueLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(AddWorkPerformedModalV3);
